import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import LivePage from '../pages/LivePage';
import { Header } from '../components/Header';

const LiveRoutes = () => {
  const { path } = useRouteMatch();
  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <Header route="Live" />
      <Switch>
        <Route exact path={path} component={LivePage} />
      </Switch>
    </div>
  );
};

export default LiveRoutes;
